import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import DisplayAS400Id from "@/components/common/DisplayAS400Id/DisplayAS400Id"

interface ProductTestInfoItemProps {
  label: string
  value: string | undefined | number | null
  isAS400shown?: boolean
  publicId?: string | null
}

export const ProductTestInfoItem: FC<ProductTestInfoItemProps> = ({
  label,
  value,
  isAS400shown = false,
  publicId = null,
}) => {
  return (
    <Box className='flex flex-col items-start justify-start' data-test='product-test-info-item'>
      <Typography className='whitespace-pre-line text-sm font-bold text-gray-700'>{label}</Typography>
      <Typography variant='body2' className='mb-2 text-gray-700'>
        {value ?? "-"}
      </Typography>
      {isAS400shown && publicId && <DisplayAS400Id id={publicId} />}
    </Box>
  )
}
